var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"transparent",attrs:{"dense":"","flat":""}},[_c('div',{staticClass:"heading font-weight-bold header-decoration",class:{ pointer: _vm.titleTo },on:{"click":_vm.onTitleClicked}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-spacer'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }